import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  FUNDING_INSTRUMENT_OPTIONS,
  FundingInstrument,
} from '@/pages/instruments/new-instrument/constants/funding-instruments'

export interface FundingInstrumentFormFieldProps {}

export const FundingInstrumentFormField: React.FC<FundingInstrumentFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ funding_instrument: string | null }>()
  return (
    <FormField
      name="funding_instrument"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Funding Instrument</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone={'None'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('funding_instrument', value ? (value as FundingInstrument) : null, {
                  shouldValidate: true,
                })
              }
              options={FUNDING_INSTRUMENT_OPTIONS}
              placeholder={'Select a funding instrument...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
